export default __webpack_public_path__ + "static/media/Thug's Leggings of the Black Arts.de164c90.jpg";